import { render } from "./ArtisanBody.vue?vue&type=template&id=023afdae&scoped=true"
import script from "./ArtisanBody.vue?vue&type=script&lang=js"
export * from "./ArtisanBody.vue?vue&type=script&lang=js"

import "./ArtisanBody.vue?vue&type=style&index=0&id=023afdae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023afdae"]])

export default __exports__